module.exports = __webpack_public_path__ + "img/maintenance-10.0a177285.png";